export default __webpack_public_path__ + "static/media/archycontact.1992650c.webp";